import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import api from '../config/axios';
import { RootState } from '../store/store';

export interface BusinessUnit {
  id: number;
  name: string;
  ico: string | null;
  dic: string | null;
  address: string | null;
  contact_person: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const useBusinessUnits = () => {
  const [businessUnits, setBusinessUnits] = useState<BusinessUnit[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { user } = useSelector((state: RootState) => state.auth);

  const fetchBusinessUnits = useCallback(async () => {
    if (!user) {
      console.log('No user found, skipping business units fetch');
      return;
    }
    
    try {
      console.log('Fetching business units for user:', user.id);
      setLoading(true);
      setError(null);
      const response = await api.get('/business-units');
      console.log('Business units response:', response.data);
      setBusinessUnits(response.data.businessUnits || []);
    } catch (err: any) {
      console.error('Error fetching business units:', err);
      console.error('Error details:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status
      });
      setError('Chyba při načítání firem');
      // Set empty array on error to prevent crashes
      setBusinessUnits([]);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user && user.id) {
      fetchBusinessUnits();
    } else {
      console.log('User not ready yet:', user);
      setBusinessUnits([]);
    }
  }, [user, fetchBusinessUnits]);

  // Ensure we always return an array
  const safeBusinessUnits = Array.isArray(businessUnits) ? businessUnits : [];
  
  return {
    businessUnits: safeBusinessUnits,
    loading,
    error,
    refetch: fetchBusinessUnits
  };
};
